// public path for CDN-delivered files is not known at compile time
// we can set at runtime via __webpack_public_path__
__webpack_public_path__ = mediaPrefix + '/builds/';



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/config/webpackPublicPath.js